export const navItems = [
  { label: '首页', href: '#top' },
  { label: '爆料速报', href: '#brief' },
  { label: '事件深扒', href: '#dig' },
  { label: '实锤档案', href: '#archive' },
  { label: '全梳理时间线', href: '#timeline' },
  { label: '爆料热榜', href: '#ranking' },
  { label: '专栏作者', href: '#authors' },
];

export const tickerItems = [
  '独家｜当晚后台录音第三段已上传，时长 4 分 12 秒',
  '补充｜合作方流出的结算单与合约日期对不上',
  '核实｜涉事工作室注销时间早于事件爆发 11 天',
  '解读｜三方声明口径互相矛盾，时间线出现 6 小时空窗',
  '进展｜疑似当事人小号被扒出，点赞记录成关键线索',
  '跟进｜品牌方连夜下架联名物料，官旗页面已清空',
];

export const heroFeature = {
  tag: '事件深扒 · 独家',
  title: '深夜录音与注销的工作室：一条被剪掉 6 小时的时间线',
  summary:
    '从当晚后台录音、合作方结算单到工作室悄然注销，我们把散落各处的线索拼回同一张时间轴。三条独立证据链互相咬合，指向同一个被忽略的环节。',
  author: '深扒组 · 老陈',
  date: '2026-09-12',
  readTime: '12 分钟',
  views: '28.6 万',
  image:
    'https://readdy.ai/api/search-image?query=abstract%20dramatic%20swirling%20crimson%20and%20amber%20ink%20smoke%20on%20deep%20charcoal%20background%2C%20cinematic%20high%20contrast%20artistic%20texture%2C%20moody%20editorial%20poster%2C%20no%20text%2C%20no%20people&width=1600&height=1000&seq=hero-18bl-01&orientation=landscape',
};

export const heroSide = [
  {
    id: 'hs-1',
    tag: '实锤',
    title: '第三段录音曝光：那句被消音的话，才是真正的转折点',
    meta: '2 小时前 · 深扒组',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20microphone%20silhouette%20blurred%20in%20warm%20golden%20light%20on%20dark%20background%2C%20podcast%20recording%20mood%2C%20artistic%20editorial%20close%20up%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=hero-side-18bl-01&orientation=landscape',
  },
  {
    id: 'hs-2',
    tag: '梳理',
    title: '把 17 份公开声明按时间排好，矛盾点自己浮出来了',
    meta: '4 小时前 · 编辑部',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20tangled%20red%20threads%20on%20neutral%20cream%20paper%20background%2C%20minimal%20editorial%20concept%2C%20soft%20shadows%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=hero-side-18bl-02&orientation=landscape',
  },
];

export const briefList = [
  { id: 'b-01', time: '09:42', title: '合作方深夜删除的招商推文被网友截图存档', cat: '独家', hot: true },
  { id: 'b-02', time: '09:10', title: '当事人后援会宣布暂停应援，公告未说明原因', cat: '进展', hot: false },
  { id: 'b-03', time: '08:35', title: '涉事品牌官网联名页于凌晨三点悄然下线', cat: '核实', hot: false },
  { id: 'b-04', time: '08:01', title: '三段录音比对：背景杂音指向同一个后台通道', cat: '深扒', hot: true },
  { id: 'b-05', time: '07:26', title: '疑似小号点赞记录被扒，时间与爆料节点高度重合', cat: '线索', hot: false },
  { id: 'b-06', time: '06:50', title: '仲裁申请材料流出，金额一栏被刻意打码', cat: '证据', hot: false },
  { id: 'b-07', time: '00:12', title: '工作室工商信息变更，法人代表在事发前完成退出', cat: '实锤', hot: true },
  { id: 'b-08', time: '23:48', title: '现场目击者发声：当晚十一点后基本没人进出', cat: '线人', hot: false },
];

export const digFeatures = [
  {
    id: 'd-01',
    tag: '头条深扒',
    title: '从一张结算单看整条利益链：钱到底进了谁的口袋',
    summary:
      '我们拿到三份不同来源的结算单，金额、日期、项目名各不相同却指向同一笔款项。把银行流水与合同逐条比对后，那个"消失的中间人"第一次有了名字。',
    author: '老陈',
    date: '2026-09-11',
    readTime: '15 分钟',
    views: '19.4 万',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20close%20up%20of%20warm%20paper%20documents%20and%20amber%20light%20gradients%20on%20dark%20wood%2C%20investigative%20editorial%20mood%2C%20artistic%20blurred%20background%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=dig-18bl-01&orientation=landscape',
  },
  {
    id: 'd-02',
    tag: '深扒',
    title: '被删掉的第 47 分钟：监控时间戳为什么少了一格',
    summary: '同一段素材在三个平台流出，只有一版的时间戳连续。差异恰恰出现在最关键的 47 分钟。',
    author: '阿禾',
    date: '2026-09-11',
    readTime: '9 分钟',
    views: '11.2 万',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20shattered%20glass%20texture%20with%20crimson%20light%20reflections%20on%20dark%20surface%2C%20dramatic%20editorial%20concept%2C%20no%20text%2C%20no%20people&width=1000&height=700&seq=dig-18bl-02&orientation=landscape',
  },
  {
    id: 'd-03',
    tag: '深扒',
    title: '同一句台词两个版本：剪辑室里的第二批文件',
    summary: '对比公开版本与送审版本，被替换的不只是画面，还有两处关键对白。',
    author: '深喉',
    date: '2026-09-10',
    readTime: '11 分钟',
    views: '8.7 万',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20film%20festival%20atmosphere%20with%20golden%20light%20leaks%20and%20deep%20red%20velvet%20texture%2C%20cinematic%20artistic%20background%2C%20no%20text%2C%20no%20people&width=1000&height=700&seq=dig-18bl-03&orientation=landscape',
  },
];

export const wallItems = [
  {
    id: 'w-01',
    size: 'large',
    tag: '实锤',
    title: '工商变更全记录：事发前 11 天，法人完成退出',
    summary: '把三次变更的时间点摊开看，退出动作精确卡在爆料前夜，这个"巧合"值得单独写一篇。',
    meta: '深扒组 · 3 小时前 · 6.4 万阅读',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20stack%20of%20anonymous%20documents%20and%20folders%20under%20warm%20lamp%20light%2C%20investigative%20archive%20mood%2C%20soft%20focus%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=wall-18bl-01&orientation=landscape',
  },
  {
    id: 'w-02',
    size: 'small',
    tag: '线索',
    title: '小号点赞记录成关键拼图',
    meta: '5 小时前',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20neon%20warning%20glow%20in%20amber%20and%20red%20over%20dark%20textured%20concrete%2C%20investigative%20news%20mood%2C%20artistic%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=wall-18bl-02&orientation=landscape',
  },
  {
    id: 'w-03',
    size: 'small',
    tag: '声音',
    title: '三段录音的背景杂音比对',
    meta: '6 小时前',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20city%20night%20skyline%20bokeh%20in%20warm%20amber%20and%20deep%20red%20tones%2C%20distant%20blurry%20lights%2C%20artistic%20editorial%20background%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=wall-18bl-03&orientation=landscape',
  },
  {
    id: 'w-04',
    size: 'small',
    tag: '回应',
    title: '工作室声明里的三处前后矛盾',
    meta: '7 小时前',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20tangled%20red%20threads%20on%20neutral%20cream%20paper%20background%2C%20minimal%20editorial%20concept%2C%20soft%20shadows%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=wall-18bl-04&orientation=landscape',
  },
  {
    id: 'w-05',
    size: 'small',
    tag: '人物',
    title: '那个从未露面的"中间人"',
    meta: '9 小时前',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20blurred%20backstage%20curtain%20in%20warm%20amber%20and%20deep%20red%2C%20silhouette%20free%20empty%20stage%2C%20artistic%20cinematic%20mood%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=wall-18bl-05&orientation=landscape',
  },
  {
    id: 'w-06',
    size: 'small',
    tag: '数据',
    title: '热搜曲线的两次异常拉升',
    meta: '11 小时前',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20glowing%20data%20line%20chart%20in%20amber%20and%20crimson%20over%20dark%20gradient%2C%20analytic%20editorial%20concept%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=wall-18bl-06&orientation=landscape',
  },
];

export const evidenceFiles = [
  { id: 'e-1', type: '录音', icon: 'ri-mic-line', title: '后台录音 · 第三段', desc: '时长 4 分 12 秒，含两处明显消音', verified: true, date: '09-12' },
  { id: 'e-2', type: '聊天记录', icon: 'ri-chat-3-line', title: '工作群对话截图', desc: '共 23 张，时间跨度 5 天，已做交叉比对', verified: true, date: '09-11' },
  { id: 'e-3', type: '合同', icon: 'ri-file-text-line', title: '合作补充协议', desc: '第 4 条与公开声明口径不一致', verified: true, date: '09-11' },
  { id: 'e-4', type: '转账', icon: 'ri-exchange-dollar-line', title: '银行流水（打码）', desc: '金额一栏被遮挡，日期可辨', verified: false, date: '09-10' },
  { id: 'e-5', type: '工商', icon: 'ri-building-2-line', title: '企业变更记录', desc: '法人在事发前 11 天完成退出', verified: true, date: '09-10' },
  { id: 'e-6', type: '影像', icon: 'ri-video-line', title: '现场监控片段', desc: '时间戳在第 47 分钟出现断点', verified: false, date: '09-09' },
];

export const timelineItems = [
  { time: '08-28 21:10', title: '合作方内部会议', desc: '据线人透露，会上首次提出调整分成比例，双方未达成一致。', tag: '起点' },
  { time: '09-01 14:30', title: '工作室完成工商变更', desc: '法人代表退出，新增一名自然人股东，工商信息可公开查询。', tag: '关键' },
  { time: '09-05 23:40', title: '联名物料首次上架', desc: '品牌官旗上线联名专区，三天后悄然下线。', tag: '铺垫' },
  { time: '09-09 02:15', title: '第一段录音流出', desc: '匿名账号发布 90 秒片段，当晚转发破十万。', tag: '爆发' },
  { time: '09-10 18:00', title: '工作室发布声明', desc: '声明的第 2 段与第 5 段时间表述互相矛盾。', tag: '回应' },
  { time: '09-12 09:42', title: '第三段录音曝光', desc: '完整版包含被消音的两句话，指向同一后台通道。', tag: '最新' },
];

export const hotRanking = [
  { rank: 1, title: '深夜录音第三段完整版流出，消音内容成焦点', heat: '98.6 万', trend: 'up', tag: '实锤' },
  { rank: 2, title: '工作室注销时间线被扒，比爆料早 11 天', heat: '76.2 万', trend: 'up', tag: '深扒' },
  { rank: 3, title: '品牌方连夜下架联名，官旗页面已清空', heat: '63.9 万', trend: 'flat', tag: '进展' },
  { rank: 4, title: '疑似当事人小号点赞记录曝光', heat: '51.4 万', trend: 'up', tag: '线索' },
  { rank: 5, title: '结算单金额对不上，中间人首次有了名字', heat: '44.8 万', trend: 'down', tag: '证据' },
  { rank: 6, title: '17 份公开声明时间线梳理完成', heat: '37.1 万', trend: 'flat', tag: '梳理' },
  { rank: 7, title: '监控时间戳第 47 分钟断点引热议', heat: '29.5 万', trend: 'up', tag: '细节' },
  { rank: 8, title: '后援会宣布暂停应援', heat: '22.3 万', trend: 'down', tag: '动态' },
  { rank: 9, title: '仲裁申请材料流出，金额被刻意打码', heat: '18.7 万', trend: 'flat', tag: '文件' },
  { rank: 10, title: '现场目击者还原当晚经过', heat: '12.9 万', trend: 'up', tag: '线人' },
];

export const columnists = [
  {
    id: 'c-1',
    name: '老陈',
    role: '深扒组主笔',
    bio: '专注事件时间线还原，擅长把碎片线索拼成完整链条，代表作《结算单背后》。',
    posts: 128,
    followers: '4.2 万',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20studio%20portrait%20of%20a%20person%20in%20warm%20soft%20lighting%2C%20minimal%20neutral%20cream%20background%2C%20artistic%20blurred%2C%20no%20text&width=600&height=600&seq=author-18bl-01&orientation=squarish',
  },
  {
    id: 'c-2',
    name: '阿禾',
    role: '影像线索编辑',
    bio: '从监控、截图与视频帧里找破绽，专治"时间戳对不上"。',
    posts: 96,
    followers: '3.1 万',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20studio%20portrait%20of%20a%20person%20in%20warm%20amber%20lighting%2C%20minimal%20soft%20beige%20background%2C%20artistic%20blurred%2C%20no%20text&width=600&height=600&seq=author-18bl-02&orientation=squarish',
  },
  {
    id: 'c-3',
    name: '深喉',
    role: '档案整理',
    bio: '负责实名实锤归档，每一条证据都标注来源与校验状态。',
    posts: 152,
    followers: '5.6 万',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20studio%20portrait%20of%20a%20person%20in%20warm%20golden%20lighting%2C%20minimal%20warm%20gray%20background%2C%20artistic%20blurred%2C%20no%20text&width=600&height=600&seq=author-18bl-03&orientation=squarish',
  },
];

export const footerColumns = [
  {
    title: '栏目',
    links: [
      { label: '爆料速报', href: '#brief' },
      { label: '事件深扒', href: '#dig' },
      { label: '实锤档案', href: '#archive' },
      { label: '全梳理时间线', href: '#timeline' },
    ],
  },
  {
    title: '专题',
    links: [
      { label: '深夜录音事件', href: '#dig' },
      { label: '结算单之谜', href: '#dig' },
      { label: '时间戳断点', href: '#archive' },
      { label: '爆料热榜', href: '#ranking' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '编辑部说明', href: '#authors' },
      { label: '证据校验标准', href: '#archive' },
      { label: '投稿与线索', href: '#subscribe' },
      { label: '免责声明', href: '#footer' },
    ],
  },
];